import { Outlet } from 'react-router-dom';

// ==============================|| BASE LAYOUT ||============================== //

export default function IcivetLayout() {
  return (<Outlet />);
}
